// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2b95c2e3","453":"76e035ed","455":"1af1ac17","977":"38ac4acb"}[chunkId] + ".chunk.js";
};